import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

class RunnerGovernanceController {
  isMobile: boolean;
  helpUri: string;
  constructor(
    private browserUtilsService: SharedAngular.BrowserUtilsService,
    private $state: angular.ui.IStateService,
    private APP_CONFIG: SharedAngular.APP_CONFIG,
    private brandingService: SharedAngular.BrandingService
  ) {
    if (!this.APP_CONFIG.enableGovernance) {
      this.$state.go(STATE_MAPPINGS.flowsactive);
    }
    this.isMobile = this.browserUtilsService.isMobileDevice();
    this.helpUri = this.brandingService.getBrandedHelpUri(
      'https://help.flowingly.net/en/articles/11077945-governance'
    );
  }
}
angular
  .module('flowingly.runner.governance')
  .controller('runnerGovernanceController', [
    'browserUtilsService',
    '$state',
    'APP_CONFIG',
    'brandingService',
    function (browserUtilsService, state, APP_CONFIG, brandingService) {
      return new RunnerGovernanceController(
        browserUtilsService,
        state,
        APP_CONFIG,
        brandingService
      );
    }
  ]);
